import React from 'react';
import './Toolbar.css';

export default function Toolbar (props) {
  const { children } = props;

  return <div className='toolbar'>
    <div>
      {children}
    </div>
  </div>;
}